import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function Brightness5Icon(props: IconProps) {
    return <Icon {...props} iconKey={"brightness_5"}/>
}
